import { useCallback, useEffect, useMemo } from 'react'

import { useUnit } from 'effector-react'
import Countdown from 'react-countdown'

import { Button } from '@/components/ui/button.tsx'
import { Tooltip } from '@/components/ui/tooltip.tsx'
import { DIALOG_TYPE } from '@/dialogs/constants.ts'
import { $account } from '@/models/account.ts'
import { openDialog } from '@/models/dialogs.ts'
import { useAccount } from '@/modules/accounts/hooks/useAccounts'

import { TimeBox } from './TimeBox.tsx'

export const LicenseValidationHandler = () => {
  const account = useUnit($account)
  const { owner } = useAccount()

  const dueDatePassed = account?.earliestLicenceMillisUntilFailureExpiry === 0
  const dueDate = useMemo(
    () =>
      account?.earliestLicenceMillisUntilFailureExpiry
        ? new Date(
            Date.now() + account?.earliestLicenceMillisUntilFailureExpiry || 0,
          )
        : null,
    [account?.earliestLicenceMillisUntilFailureExpiry],
  )

  const handleOpenFailedPaymentsDialog = useCallback(() => {
    openDialog({
      type: DIALOG_TYPE.PAYMENT_FAILED,
      paymentUrls: owner?.invoiceUrls ?? [],
      closable: !dueDatePassed,
      isOwner: account?.owner,
    })
  }, [account?.owner, dueDatePassed, owner?.invoiceUrls])

  useEffect(() => {
    if (!!account?.earliestLicenceMillisUntilFailureExpiry || dueDatePassed) {
      handleOpenFailedPaymentsDialog()
    }
  }, [
    account?.earliestLicenceMillisUntilFailureExpiry,
    dueDatePassed,
    handleOpenFailedPaymentsDialog,
  ])

  if (!dueDate) {
    return null
  }

  return (
    <div className="flex gap-2">
      <Button
        onClick={handleOpenFailedPaymentsDialog}
        variant="destructive"
      >
        Payment failed
      </Button>
      <Tooltip content="The time until this account will be blocked.">
        <Countdown
          date={dueDate}
          renderer={(left) => {
            return (
              <div className="flex items-center">
                <TimeBox>{left.days}d</TimeBox>
                <span className="mx-1 inline-block text-sm font-medium text-text-default">
                  :
                </span>
                <TimeBox>{left.formatted.hours}h</TimeBox>
                <span className="mx-1 inline-block text-sm font-medium text-text-default">
                  :
                </span>
                <TimeBox>{left.formatted.seconds}s</TimeBox>
              </div>
            )
          }}
        />
      </Tooltip>
    </div>
  )
}
